export const userSearchType = [
    {
        id: "jober",
        title: "Jober"
    },
    {
        id: "user",
        title: "Cliente"
    }
];